/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/
export const PspErrorCodes = {
  WHITELIST_EMAIL:
    'You are unable to sign up at this time, Passport services are in closed beta for now. Please watch out for further updates!',
};
export interface PspError {
  message: string;
  httpCode: number;
  details?: string;
  requestValue?: string;
  hideNotification?: boolean;
  statusReason?: string;
  statusReasonCode?: string;
}

export interface PspErrorApiResponse {
  error: PspRequestErrorApiResponse | null;
  status: number;
}

export interface PspRequestErrorApiResponse {
  message: string;
  http_code: number;
  details?: string;
  request_value?: string;
  StatusReason?: {
    Description?: string;
    StatusReasonCode?: string;
  };
}

/**
 * This function is used to convert the API response to a PspError object.
 * @param response API response
 * @returns PspError object
 */
export function pspErrorFromApiResponse(response: PspErrorApiResponse): PspError {
  return {
    message: response?.error?.message
      ? response.error.message
      : `An error occurred with code: ${response.status}`,
    httpCode: response?.error?.http_code ? response.error?.http_code : response.status,
    ...(response?.error?.details && {details: response.error.details}),
    ...(response?.error?.request_value && {requestValue: response.error.request_value}),
  };
}

/**
 * This function is used to convert the API response to a PspError object.
 * @param response API response
 * @returns PspError object
 */
export function spiErrorFromApiResponse(response: PspErrorApiResponse): PspError {
  return {
    message: response?.error?.message
      ? response.error.message
      : `An error occurred with code: ${response.status}`,
    httpCode: response?.error?.http_code ? response.error?.http_code : response.status,
    ...(response?.error?.details && {details: response.error.details}),
    ...(response?.error?.request_value && {requestValue: response.error.request_value}),
    ...(response?.error?.StatusReason?.Description && {
      statusReason: response.error.StatusReason.Description,
    }),
    ...(response?.error?.StatusReason?.StatusReasonCode && {
      statusReasonCode: response.error.StatusReason.StatusReasonCode,
    }),
  };
}
